var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlanSpace f-zz"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"400px","width":"350px"},attrs:{"src":require(".././assets/wnr.png"),"alt":""}}),_c('div',{staticStyle:{"font-size":"14px","color":"#999"}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }